import { useTenant } from "hooks/settings";
import { Loaded, loadedEndpoint } from "models/loaded";
import {
  StrategyDashboardEditingData,
  useGetStrategyDashboardEditingQuery,
  useGetStrategyDashboardEditingRecipesByDateQuery,
} from "src/store/api/generatedApi";

export const useStrategyDashboardEditing = (
  start?: string,
  end?: string
): Loaded<StrategyDashboardEditingData> => {
  return loadedEndpoint(
    useGetStrategyDashboardEditingQuery({
      tenantName: useTenant(),
      start,
      end,
    })
  );
};

export const useStrategyDashboardEditingRecipesByDate = (
  heatDate: string,
  productGroupName: string
) => {
  return useGetStrategyDashboardEditingRecipesByDateQuery({
    tenantName: useTenant(),
    heatDate,
    productGroupName,
  });
};
